import { lazy } from 'react';
import { Megaphone } from 'lucide-react';
import type { Notice } from '@app/shared';
import type { WebModule } from '../../app/types.ts';
import { familyRecords, scoreText } from '../../platform/search.ts';

export const boardModule: WebModule = {
  id: 'board',
  label: 'Family board',
  icon: Megaphone,
  path: '/board',
  nav: { group: 'family', order: 30 },
  routes: [{ path: 'board', lazy: async () => ({ Component: (await import('./BoardScreens.tsx')).BoardScreen }) }],
  home: [{ id: 'board', title: 'Family board', order: 5, component: lazy(() => import('./BoardScreens.tsx').then((m) => ({ default: m.NoticesSection }))) }],
  async search(q, ctx) {
    const notices = await familyRecords<Notice>('notices', ctx.familyId);
    return notices
      .map((n) => ({ n, score: scoreText(q, [n.body]) }))
      .filter((x) => x.score > 0)
      .map(({ n, score }) => ({
        key: `notices:${n.id}`,
        title: n.body.slice(0, 80),
        subtitle: `Notice from ${ctx.nameOf(n.createdBy)}`,
        to: `/board?notice=${n.id}`,
        group: 'Family board',
        icon: Megaphone,
        score,
      }));
  },
};
